"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstablishLoyaltyConnectionPayloadToJSON = exports.EstablishLoyaltyConnectionPayloadFromJSONTyped = exports.EstablishLoyaltyConnectionPayloadFromJSON = void 0;
function EstablishLoyaltyConnectionPayloadFromJSON(json) {
    return EstablishLoyaltyConnectionPayloadFromJSONTyped(json, false);
}
exports.EstablishLoyaltyConnectionPayloadFromJSON = EstablishLoyaltyConnectionPayloadFromJSON;
function EstablishLoyaltyConnectionPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': json['code'],
    };
}
exports.EstablishLoyaltyConnectionPayloadFromJSONTyped = EstablishLoyaltyConnectionPayloadFromJSONTyped;
function EstablishLoyaltyConnectionPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
    };
}
exports.EstablishLoyaltyConnectionPayloadToJSON = EstablishLoyaltyConnectionPayloadToJSON;
//# sourceMappingURL=EstablishLoyaltyConnectionPayload.js.map